import { graphql, useStaticQuery } from 'gatsby';

import { useFlatten } from './use-flatten';
import { getProperty } from 'utils';

export const useStaticHomepage = () => {
	const results = useStaticQuery(query) || {};
	const key = 'squidex.findHomepageSingleton';

	return useFlatten(getProperty(results, key) || {});
};

const query = graphql`
	query useHomepageQuery {
		squidex {
			findHomepageSingleton {
				data {
					seo {
						de {
							title
							description
						}
					}

					infobox {
						de {
							title
						}
					}

					teaserImage {
						iv {
							localFile {
								childImageSharp {
									gatsbyImageData(layout: FULL_WIDTH, quality: 100)
								}
							}
							...SquidexLocalFileProps
						}
					}

					blockIntroLink {
						iv {
							data {
								path {
									de
								}
							}
						}
					}

					blockDevelopLink {
						iv {
							data {
								path {
									de
								}
							}
						}
					}

					blockDevelopImage {
						iv {
							localFile {
								childImageSharp {
									gatsbyImageData(layout: CONSTRAINED, width: 768, quality: 100)
								}
							}
							...SquidexLocalFileProps
						}
					}

					blockConstructLink {
						iv {
							data {
								path {
									de
								}
							}
						}
					}

					blockConstructImage {
						iv {
							localFile {
								childImageSharp {
									gatsbyImageData(layout: CONSTRAINED, width: 768, quality: 100)
								}
							}
							...SquidexLocalFileProps
						}
					}

					develop {
						de {
							title
							text
						}
					}

					projects {
						de {
							title
							text
						}
					}

					about {
						de {
							text
							link {
								data {
									path {
										de
									}
								}
							}
							linkText
						}
					}
				}
			}
		}
	}
`;
